// Truy cập Firestore theo tenant (Client SDK / browser-side).
// Đối ứng client của lib/tenant-db.ts. Mọi page (app)/* đọc Firestore trực tiếp PHẢI dùng helper này
// thay vì collection(db, 'bookings') — nếu không sẽ rò rỉ chéo tenant + vi phạm Security Rules.

import { collection, doc, type Firestore } from 'firebase/firestore';

export const TENANTS = 'tenants';
// Dùng cho trang client ĐỨNG NGOÀI TenantProvider (vd /hk, /incident/[id] mở bằng link/token,
// không có auth context). Phase 1 Gardenia-only. TODO(phase4): resolve tenant từ token/route.
export const DEFAULT_TENANT_ID = 'gardenia';

function assertTenantId(tenantId: string): string {
  if (!tenantId || typeof tenantId !== 'string' || tenantId.includes('/')) {
    throw new Error(`Invalid tenantId: ${JSON.stringify(tenantId)}`);
  }
  return tenantId;
}

/** Collection dữ liệu của tenant: tenants/{tenantId}/{name} */
export function tenantColClient(db: Firestore, tenantId: string, name: string) {
  return collection(db, TENANTS, assertTenantId(tenantId), name);
}

/** Doc trong subcollection: tenants/{tenantId}/{name}/{docId} */
export function tenantDocClient(db: Firestore, tenantId: string, name: string, docId: string) {
  return doc(db, TENANTS, assertTenantId(tenantId), name, docId);
}

/** Doc hệ thống per-tenant: tenants/{tenantId}/system/{name} */
export function tenantSystemDocClient(db: Firestore, tenantId: string, name: string) {
  return doc(db, TENANTS, assertTenantId(tenantId), 'system', name);
}
